<script lang="ts">
    import { _ } from "svelte-i18n";
    import type { LayersControlManager } from "./LayersControlManager";
    import LayerListItemGroup from "./LayerListItemGroup.svelte";
    import TitledControl from "../../components/map/controls/TitledControl.svelte";
    import { writable } from "svelte/store";

    export let manager: LayersControlManager;
    const layerGroupManagers = manager.getLayerListItemGroupManagerStore();
    const modelTranslationKeyStore = manager.getModelTranslationKeyStore();
    const showCyclingScoreToggleStore =
        manager.getShowCyclingScoreToggleStore();
    const showCyclingScoreStore = manager.getShowCyclingScoreStore();
    const showRelevantLocationsToggleStore =
        manager.getShowRelevantLocationsToggleStore();
    const showRelevantLocationsStore = manager.getShowRelevantLocationsStore();

    $: {
        $layerGroupManagers.forEach((l) => console.log(l));
    }
</script>

<TitledControl class="layers-control bg-light" {manager}>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <h5 slot="title" class="mb-0" on:click={() => manager.onToggleCollapsed()}>
        <button class="border-0 bg-transparent fe fe-layers me-2"></button
        ><strong>{$_(`${$modelTranslationKeyStore}.layers.title`)}</strong>
    </h5>
    <div slot="content" class="input-group input-group-lg">
        <div class="list-group w-100">
            <div class="content rounded-bottom">
                {#each $layerGroupManagers as layerGroupManager}
                    <LayerListItemGroup manager={layerGroupManager} />
                {/each}
                {#if $showCyclingScoreToggleStore}
                    <div
                        class="list-group-item border-0 border-top p-4 py-3 bg-light"
                        aria-current="true">
                        <div class="d-flex w-100 justify-content-between">
                            <h5 class="mb-1">
                                {$_(`layers.showcyclingscore`)}
                            </h5>
                            <div class="form-check form-switch">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    bind:checked={$showCyclingScoreStore} />
                            </div>
                        </div>
                    </div>
                {/if}
                {#if $showRelevantLocationsToggleStore}
                    <div
                        class="list-group-item border-0 border-top p-4 py-3 bg-light"
                        aria-current="true">
                        <div class="d-flex w-100 justify-content-between">
                            <h5 class="mb-1">
                                {$_(`layers.showrelevantlocations`)}
                            </h5>
                            <div class="form-check form-switch">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    bind:checked={$showRelevantLocationsStore} />
                            </div>
                        </div>
                    </div>
                {/if}
            </div>
        </div>
    </div>
    <div
        slot="content-collapsed"
        class="d-flex flex-column justify-content-center align-items-center">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <button
            on:click={() => manager.onToggleCollapsed()}
            class="border-0 bg-transparent icon-collapsed">
            <i class="fe fe-layers"></i>
        </button>
    </div>
</TitledControl>
